
import { defineComponent, PropType } from 'vue';
import { _CreatedUser } from '../composables/index';
import { IUserInfoLogs } from '@/api/manage-app/user-info/index.d';

export default defineComponent({
  name: 'DevAccountLogs',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    logData: {
      type: Array as PropType<IUserInfoLogs[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const {
      tableLoading,
      handleLogClose,
    } = _CreatedUser({}, emit);

    return {
      tableLoading,
      handleLogClose,
    };
  },
});
